import React from 'react'
import Experiment from '@mc/experiments-react'
import { useTranslation } from '@mc/i18n'
import { EXPERIMENT_FLAG_KEY } from '../constants'
import { useExperimentCriteria } from '../hooks/useExperimentCriteria'
import { GIFT_PAGE_EXPERIMENT_I18N_NAMESPACE } from '../i18n/i18nInstance'

interface Pen5108TitleWrapperProps {
  control?: React.ReactNode
}

export const Pen5108TitleWrapper = ({ control }: Pen5108TitleWrapperProps) => {
  const { t } = useTranslation(GIFT_PAGE_EXPERIMENT_I18N_NAMESPACE)
  const { experimentCriteria } = useExperimentCriteria()
  if (!experimentCriteria) return control

  return (
    <Experiment
      name={EXPERIMENT_FLAG_KEY}
      control={() => control}
      variant_1={() => (
        <h1 className='mc-text-d2 mc-text--brand mc-text--uppercase mc-mb-2'>
          <div>{t('hero.title_1')}</div>
          <div className='mc-text-color--primary'>{t('hero.title_2')}</div>
        </h1>
      )}
      track={false}
    />
  )
}
